<template>
  <div class="loading" v-loading="loading"></div>
</template>

<script>
import { search } from '@/api/common'
import { getBase64Avatar } from '@/api/center'
import { MessageBox } from 'element-ui'
export default {
  name: 'Loading',
  data () {
    return {
      val: this.$route.params.data || this.$route.query.data,
      searchtype: this.$route.params.searchtype,
      loading: true,
      timer: '',
      time: 3
    }
  },
  mounted () {
    // 如果为空则返回首页
    if (!this.val) {
      this.$router.replace({ path: '/' })
      return
    }
    let data
    if (this.searchtype === undefined) {
      data = {
        k: this.val,
        from: 0,
        size: 20
      }
    } else {
      data = {
        k: this.val,
        from: 0,
        size: 20,
        searchtype: this.searchtype
      }
    }
    // 搜索
    let _this = this
    search(data)
      .then(res => {
        if (!res.data || !res.data.total || !res.typedata.length) {
          this.$confirm(
            '未搜索到有关该关键词的内容,系统将在3秒后返回上一页',
            '提 示',
            {
              confirmButtonText: '返回上一页',
              // type: "warning",
              showCancelButton: false,
              beforeClose: (action, instance, done) => {
                clearInterval(this.timer)
                done()
                this.$router.go(-1)
              },
              callback (action, instance) {}
            }
          )
            .then(() => {})
            .catch(() => {})

          this.timer = setInterval(() => {
            this.time--
            if (this.time === 0) {
              MessageBox.close()
              clearInterval(this.timer)
              this.$router.go(-1)
            }
          }, 1000)
          return
        }
        res.data.obj.forEach((item, index) => {
          if (item.keyword) {
            res.data.obj[index].keywordList = item.keyword.split(';')
          }

          // this.setAvatar(item,index).then(res=>{
          //   // item.avatar = res
          //   res.data.obj[index].avatar = res
          // })
        })

        if (!parseInt(res.searchtype)) {
          this.$router.replace({
            name: 'RetrieveField',
            params: { data: res }
          })
        } else if (parseInt(res.searchtype) === 1) {
          if (res.data.obj.length === 1) {
            this.$router.replace({
              name: 'Detail',
              query: /^\d+$/.test(res.data.obj[0].kId)
                ? { kId: res.data.obj[0].kId }
                : {
                  name: res.data.obj[0].name,
                  institute: res.data.obj[0].organization
                }
            })
            return
          }
          this.$router.replace({ name: 'RetrieveName', params: { data: res } })
        } else if (parseInt(res.searchtype) === 2) {
          this.$router.replace({ name: 'RetrieveInst', params: { data: res } })
        }
      })
      .catch(err => {
        console.log(err)
      })
  },
  methods: {
    removeModal () {
      var el_message_box = document.querySelector('.el-message-box__wrapper')
      var v_modal = document.querySelector('.v-modal')
      if (el_message_box && v_modal) {
        el_message_box.style.display = 'none'
        v_modal.parentNode.removeChild(v_modal)
      }
    },
    setAvatar (item) {
      return new Promise(resolve => {
        if (!isNaN(item.kId)) {
          getBase64Avatar({ kId: item.kId }).then(res => {
            resolve(
              res.data[0].data[0] && res.data[0].data[0].avatar
                ? res.data[0].data[0].avatar.replace(/[\r\n]/g, '')
                : ''
            )
          })
        }
      })
    }
  }
}
</script>

<style scoped>
.loading {
  width: 100vw;
  height: 100vh;
}
</style>



// WEBPACK FOOTER //
// src/components/common/Loading.vue